import Services from "./services/index.js";
import TechVisits from "./tech_visits/index.js";
import Warehouse from "./warehouse/index.js"
import Delivery from "./delivery/index.js"

export default [
  ...Services,
  ...TechVisits,
  ...Warehouse,
  ...Delivery,
]
